import React from 'react'
import { useIntl } from 'react-intl'

import { TextBadge } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/TextBadge'
import { Tooltip } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/tooltip/Tooltip'
import { BadgeShape } from '@lyrahealth-inc/ui-core-crossplatform/src/badge/constants'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

import { getProviderPairBadgePresentation, ProviderPairCounterpartStatus } from '../data/providerPairPresentation'

// Shared by messenger titles and tabs.
export const ProviderPairStatusBadge = ({
  status,
  testID = `ProviderPairStatusBadge-${status}`,
}: {
  status: ProviderPairCounterpartStatus
  testID?: string
}) => {
  const { formatMessage } = useIntl()
  const presentation = getProviderPairBadgePresentation(status)
  if (!presentation) {
    return null
  }
  const badge = (
    <TextBadge
      text={formatMessage(presentation.label)}
      shape={BadgeShape.RECT}
      preserveCase
      testID={tID(testID)}
      style={{ alignSelf: 'center' }}
    />
  )
  return presentation.tooltip ? (
    <Tooltip
      content={formatMessage(presentation.tooltip)}
      accessibilityLabel={formatMessage(presentation.tooltip)}
      hoverEnabled
      wrapperStyle={{ flexGrow: 0, flexShrink: 0, flexBasis: 'auto', alignSelf: 'center' }}
      testID={tID(`${testID}-tooltip`)}
    >
      {badge}
    </Tooltip>
  ) : (
    badge
  )
}
